import "./new-member.scss";

import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";

import HeaderContent from "@shared/ui/header-content/header-content";
import { useNewMember } from "./new-member.hook";
import TextBlock from "@shared/ui/text-block/text-block";
import { Divider } from "primereact/divider";
import FormMemberWrapper from "../form-member-wrapper/form-member-wrapper";
import ChildInfo from "@core/ui/child-info/child-info";
import ParentInfo, { ParentInfoMember } from "@core/ui/parent-info/parent-info";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { MemberFormSchema } from "@factory/form/form.rule";

export function NewMember() {
  const {
    stepperRef,
    parentMemberRef,
    parentFormData,
    childFormData,
    childFormRefs,
    childFormCount,
    isCreating,
    navigate,
    handleParentForm,
    handleParentTrigger,
    handleChildFormSubmit,
    handleAddChildForm,
    handleChildTrigger,
    handleSaveMembers,
    nextStepper,
  } = useNewMember();
  const { formatDate } = useDateTimeContext();
  const handChildrenNext = () => {
    nextStepper();
    handleChildTrigger();
  };

  const parentPanel = (
    <StepperPanel header="Parent">
      <div className="flex flex-column h-12rem">
        <FormMemberWrapper ref={parentMemberRef} onSubmit={handleParentForm} />
      </div>
      <div className="flex pt-4 justify-content-end">
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={() => handleParentTrigger()}
        />
      </div>
    </StepperPanel>
  );
  const childrenPanel = (
    <StepperPanel header="Children">
      <div className="flex flex-col flex-wrap md:flex-row gap-4">
        {Array.from({ length: childFormCount }, (_, index) => (
          <div className="border-2 border-dashed p-4" key={index}>
            <FormMemberWrapper
              ref={(el) => {
                childFormRefs.current[index] = el!;
              }}
              isChild={true}
              onSubmit={(data) => handleChildFormSubmit(data, index)}
            />
          </div>
        ))}
      </div>
      <div className="flex pt-4 justify-between">
        <section className="flex gap-4">
          <Button
            label="Back"
            severity="secondary"
            icon="pi pi-arrow-left"
            onClick={() => (stepperRef as any).current.prevCallback()}
          />
          <Button
            label="Add"
            icon="pi pi-plus"
            iconPos="right"
            outlined
            onClick={handleAddChildForm}
          />
        </section>
        <Button
          label="Finish"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={handChildrenNext}
        />
      </div>
    </StepperPanel>
  );
  const summaryPanel = (
    <StepperPanel header="Summary">
      <section className="flex flex-col h-12rem">
        <div className="flex flex-col items-center border-2 border-dashed">
          <h2 className="font-bold my-4">Summary</h2>

          <ParentInfoMember model={parentFormData as MemberFormSchema} />

          <h4>Children</h4>
          <Divider />
          <section className="flex justify-center items-center gap-4 flex-wrap mb-4">
            {childFormData.map((item, id) => (
              <ChildInfo
                key={id}
                birthday={item.birthday}
                name={`${item?.firstName} ${item?.lastName}`}
                photo={item?.photo}
              />
            ))}
          </section>
        </div>
      </section>
      <section className="flex pt-4 justify-between">
        <Button
          label="Back"
          severity="secondary"
          icon="pi pi-arrow-left"
          onClick={() => (stepperRef as any).current.prevCallback()}
        />

        <Button
          label="Save"
          disabled={isCreating}
          onClick={handleSaveMembers}
        ></Button>
      </section>
    </StepperPanel>
  );

  return (
    <div id="NewMember" className="member">
      <HeaderContent
        title="New Member"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      ></HeaderContent>

      <div className="p-7">
        <section className="grid grid-cols-1 gap-2 mb-4">
          <Stepper ref={stepperRef}>
            {parentPanel}
            {childrenPanel}
            {summaryPanel}
          </Stepper>
        </section>
      </div>
    </div>
  );
}

export default NewMember;
